<template>
  <div class="chart">
    <canvas ref="canvas" width="400" height="400"></canvas>
  </div>
</template>

<script>
  /**
   *  https://vuejsexamples.com/vuejs-wrapper-for-chartjs
   *  http://www.vue-chartjs.org/
   *
   *   "chart.js": "^2.7.3" +  "vue-chartjs": "^3.4.0"
   *
   *  Radar - http://vue-charts.hchspersonal.tk/radar
   *
   *  Hex to RGB(#43d45b >> rgba(23,231,34,0.5)
   *  https://www.webpagefx.com/web-design/hex-to-rgb/
   */
  import VueChartJs from 'vue-chartjs'

  export default {
    name: 'vRadar',
    extends: VueChartJs.Radar,
    // props: ['chartdata', 'chartoptions'],
    props:{
      chartdata: {
        type: Object,
        default: null
      },
      chartoptions: {
        type: Object,
        default: null
      }
    },
    components: {
      // 'v-radar': Radar
    },
    data() {
      return {

      }
    },
    mounted() {
      this.renderChart(
        this.chartdata,
        this.chartoptions
      )
    },
    methods: {
      updateData(chartData, chartOptions){

        // vue-chartjs
        // Region Start
        // chartdata:{
        //   labels: ['', '', ''],
        //   datasets: [
        //     {
        //       // 순차
        //       // label: 'Data One',
        //       backgroundColor: 'rgba(255,119,87,0.8)',    // #ff7757
        //       data: [20, 50, 4],
        //       // borderColor: '#54f9c9',
        //       borderWidth: 0.1,
        //       pointRadius:0
        //       // pointBackgroundColor: "rgba(179,181,198,1)",
        //       // pointBorderColor: "#fff",
        //       // pointHoverBackgroundColor: "#fff",
        //       // pointHoverBorderColor: "rgba(179,181,198,1)"
        //     },
        //     {
        //       // 반복
        //       // label: 'Data One',
        //       backgroundColor: 'rgba(255,238,48,0.8)',      // #ffee30
        //       data: [70, 10, 17],
        //       // borderColor: '#3d3c9f',
        //       borderWidth: 0.1,
        //       pointRadius:0
        //     },
        //     {
        //       // 선택
        //       // label: 'Data One',
        //       backgroundColor: 'rgba(71,181,255,0.8)',     // #47b5ff
        //       data: [50, 30, 77],
        //       // borderColor: '#1ddd65',
        //       borderWidth: 0.1,
        //       pointRadius:0
        //     }
        //   ]
        // },
        // chartoptions:{
        //   // scales: {
        //   //   // Hides the scale
        //   //   display: false,
        //   //   yAxes: [{
        //   //     ticks: {
        //   //       beginAtZero:true
        //   //     }
        //   //   }]
        //   // },
        //   responsive:true,
        //   // If want to customize width and height, maintainAspectRatio should be false
        //   maintainAspectRatio:false,
        //   legend: {
        //     display: false,
        //     labels: {
        //       fontSize: 0,
        //       fontColor: "#ee0e08",
        //     }
        //   },
        //   tooltips: {
        //     enabled: false,
        //     callbacks: {
        //       label:function (tooltipItems, data) {
        //         console.log(data);
        //         return tooltipItems.yLabel + '£'
        //       }
        //     },
        //     //Option for title font size in pixels
        //     tooltipTitleFontSize: 14,
        //     //Option for tooltip title color
        //     tooltipTitleFontColor: "#ee0e08",
        //   },
        //   title: {
        //     display: false,
        //     position: 'bottom',
        //     text: 'Custom Chart Title'
        //   }
        // }
        // Region End

        this.renderChart(chartData, chartOptions);
      }
    }
  }
</script>
<style lang="less" scoped>
  .chart{
    /*border: 1px solid red;*/
    margin-top:0px;
    width:410px;
    height:410px;
  }

  .v-radar{
    text{
      width: 100px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CodmosAnalysisRadarChart.vue